// extracted by mini-css-extract-plugin
export default {"wrapper":"z_bT","textWrapper":"z_bV"};